export var ReportTypes;
(function (ReportTypes) {
    ReportTypes["INITIAL"] = "Initiale Werbung";
    ReportTypes["BREAKPOINT_CHANGE"] = "Breakpoint Change";
    ReportTypes["REFRESH"] = "Refresh";
})(ReportTypes || (ReportTypes = {}));
//# sourceMappingURL=adsDebugging.js.map